<template>
  <el-row class="wrap-container">
    <!-- 头部 -->
    <el-col :span="24" class="top-breadcrumb">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }"><b>首页</b></el-breadcrumb-item>
        <el-breadcrumb-item>项目管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/project/list' }"><b>项目列表</b></el-breadcrumb-item>
        <el-breadcrumb-item>项目详情</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>
    <!-- 中间 -->
    <el-col :span="24" class="main">
      <!-- 左侧导航 -->
      <aside>
        <el-menu :default-active="$route.path" text-color="#000" active-text-color="#409EFF" @select="handleSelect">
          <template v-for="(item,index) in deviceCategories">
            <el-menu-item :index="'/project/detail/' + $route.params.id + '/' + item.template + '/' + item.deviceCategoryId">
              <span slot="title">{{item.deviceCategoryName}}</span>
            </el-menu-item>
          </template>
        </el-menu>
      </aside>
      <!-- 右侧内容区 -->
      <section class="router-container">
        <div class="grid-content bg-purple-light">
          <div class="content-wrapper">
            <transition name="fade" mode="out-in">
              <router-view></router-view>
            </transition>
          </div>
        </div>
      </section>
    </el-col>
  </el-row>
</template>
<script>
  export default {
    data() {
    	return {
    		deviceCategories: []
    	}
    },
    methods: {
      handleSelect(index, indexPath) {
        let deviceCategory = null;
        let deviceCategoryId = index.slice(index.lastIndexOf('/') + 1);
        this.deviceCategories.forEach(function(item, index){
          if (item.deviceCategoryId === deviceCategoryId){
            deviceCategory = item;
          }
        });
        if (deviceCategory) {
          this.$router.push({name: deviceCategory.template, params: {deviceCategoryId: deviceCategory.deviceCategoryId}});
        }
      }
    },
    mounted() {
      this.deviceCategories = JSON.parse(localStorage.getItem("PROJECT_DEVICE_CATEGORIES"));
    }
  }
</script>
<style lang="scss" scoped>
  .wrap-container {
    position: relative;
    top: 0px;
    bottom: 0px;
    width: 100%;

    .top-breadcrumb {
      height: 50px;
      line-height: 50px;
      padding: 15px 0px 0px 0px;
    }

    .main {
      display: -webkit-box;
      display: -webkit-flex;
      display: -ms-flexbox;
      display: flex;
      position: relative;
      top: 0px;
      bottom: 0px;
      width: 100%;
      overflow: hidden;

      aside {
        border-right: 1px solid #cecece;
        min-width: 50px;

        &::-webkit-scrollbar {
          display: none;
        }

        &.showSidebar {
          overflow-x: hidden;
          overflow-y: auto;
        }

        .el-menu {
          height: 100%; /*写给不支持calc()的浏览器*/
          height: -moz-calc(100% - 80px);
          height: -webkit-calc(100% - 80px);
          height: calc(100% - 80px);
          border-radius: 0px;
          border-right: 0px;
        }
      
        .el-submenu .el-menu-item {
          min-width: 60px;
        }

        .el-menu {
          width: 175px;
        }

        .el-menu--collapse {
          width: 60px;
        }

        .el-menu .el-menu-item,
        .el-submenu .el-submenu__title {
          height: 46px;
          line-height: 46px;
        }

        .el-menu-item:hover,
        .el-submenu .el-menu-item:hover,
        .el-submenu__title:hover {
          background-color: lightblue;
        }
      }

      .router-container {
        background: #fff;
        flex: 1;
        overflow-y: auto;
        padding-bottom: 1px;
        padding: 0px 0px 0px 10px;

        .content-wrapper {
          background-color: #fff;
          box-sizing: border-box;
        }
      }
    } 
  }
</style>


// WEBPACK FOOTER //
// projectDetail.vue?d86b502c